export const DEFAULT_SECTION_CODE = 'default'; // 默认的section的code


// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/flow/edit/config.js